import { Dialog } from "primereact/dialog";
import styled from "styled-components";

export const StyledDialog = styled(Dialog)`
  .p-datatable-thead > tr > th:last-child > div {
    padding-left: 17.5px;
  }
  .p-dialog-content {
    padding-bottom: 1rem;
  }

  .upload-area {
    display: flex;
    align-items: center;
    gap: 1rem;
    padding: 0.75rem 0.75rem;
    border: 2px dashed #dee2e6;
    border-radius: 6px;
    cursor: pointer;
    transition: border-color 0.2s;

    &:hover {
      border-color: #adb5bd;
    }

    i {
      font-size: 1rem;
      color: #706f7b;
    }

    p {
      margin: 0;
      color: #706f7b;
      font-size: 0.875rem;
    }
  }

  .selected-file {
    display: flex;
    align-items: center;
    padding: 0.5rem 0.75rem;
    background: #f8f9fa;
    border: 1px solid #d3d2d5;
    border-radius: 6px;

    .file-info {
      flex: 1;
      display: flex;
      align-items: center;
      gap: 0.5rem;

      i {
        color: var(--primary-color);
      }

      .file-name {
        font-weight: 500;
        font-size: 0.875rem;
      }

      .file-size {
        color: #706f7b;
        font-size: 0.75rem;
      }
    }
  }

  .cell-with-upload {
    min-width: 200px;
  }
`;
